module.exports = __webpack_public_path__ + "img/home_party_100_logo2.feb13425.png";